/**
 * Marks a block that rises in, one after another, when a Settings tab opens (see
 * SettingsPanelTransition). Put it on leaf rows, not on the containers around them.
 */
export const SETTINGS_ITEM_ATTR = { 'data-settings-item': '' } as const

/** A tab's root: its sections stack flush, each one separated from the next by a hairline. */
export const SETTINGS_PANEL_CLASS = 'flex w-full flex-col'

/** A list inside a section (passkeys, sessions, API keys): plain rows split by hairlines. */
export const SETTINGS_LIST_CLASS = 'divide-foreground/10 flex w-full flex-col divide-y'

/** One row of a SETTINGS_LIST_CLASS list: content on the left, its action on the right. */
export const SETTINGS_LIST_ITEM_CLASS = 'flex w-full items-center justify-between gap-6 py-3'
